import axios from 'axios';
import { reportToSentry } from '../../../utils/reportToSentry';

class LoginService {
  constructor() {
    this.axios = axios.create({
      baseURL: process.env.GATSBY_AUTH_API,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }
  loginUser(email, password) {
    const path = `/oauth/token/?grant_type=password&username=${encodeURIComponent(email)}&password=${encodeURIComponent(
      password,
    )}&scope=mobile_device`;

    return this.axios
      .post(
        path,
        {},
        {
          headers: {
            Authorization: `Basic ${process.env.GATSBY_BASIC_AUTH}`,
          },
        },
      )
      .then(response => {
        const { data } = response;
        if (response?.status !== 200)
          return {
            data: null,
            error: {
              status: response.status,
              message: response.data.error,
            },
          };
        return {
          data,
          error: null,
        };
      })
      .catch(error => {
        reportToSentry({
          error,
          extra: { method: 'loginUser', email },
        });
        return {
          data: null,
          error: error.code,
        };
      });
  }

  refreshToken(token) {
    const path = `/oauth/token/?grant_type=refresh_token&refresh_token=${token}&scope=mobile_device`;

    return this.axios
      .post(
        path,
        {},
        {
          headers: {
            Authorization: `Basic ${process.env.GATSBY_BASIC_AUTH}`,
          },
        },
      )
      .then(response => {
        const { data } = response;
        if (response?.status !== 200)
          return {
            data: null,
            error: {
              status: response.status,
              message: response.data.error,
            },
          };
        return {
          data,
          error: null,
        };
      })
      .catch(error => {
        reportToSentry({
          error,
          extra: { method: 'refreshToken', token },
        });
        return {
          data: null,
          error: error.code,
        };
      });
  }
}

const loginService = new LoginService();

export default loginService;
